<div class='check'>
  <div #TimerPart id="TimerPart" class="time-picker time-picker_own" >
    <select class="time-picker__select" id="Hour"  #Hour  (change)="HourChange($event)">
      <option *ngFor="let i of hours"  [value]="i"  [selected]="i+''==hour"  >
        {{i}}
      </option>
    </select>
     :
      <select class="time-picker__select" id="min" #mins  (change)="minChange($event)">
      <option *ngFor="let i of min " [value]="i" [selected]="i+''==minute">{{i}}</option>
    </select>
    <select class="time-picker__select" id="zone" #zone *ngIf="field.hourFormat!=24" (change)="meridiemChange($event)">
      <option value="AM" [selected]="meridiem=='AM'">AM</option>
      <option value="PM"[selected]="meridiem=='PM'">PM</option>
    </select>
  </div>
</div>


